import {Component, Input} from '@angular/core';
import {
    EmployeeRequestDetailsDesktopComponent
} from '@employee-pages/badge-request-page/employee-request-details/desktop/employee-request-details-desktop.component';
import {RequestReason} from '@employee-pages/badge-request-page/employee-badge-requests';
import {UserRuleReader} from '@ui-app/services/user-rules-reader.service';

@Component({
    selector: 'employee-request-details-desktop-usi',
    templateUrl: './usi-employee-request-details-desktop.component.html',
    styleUrls: ['./usi-employee-request-details-desktop.component.less']
})

export class UsiEmployeeRequestDetailsDesktopComponent extends EmployeeRequestDetailsDesktopComponent {
    @Input() visitorsTabs: RequestReason[];

    constructor(
        private userRuler: UserRuleReader
    ) {
        super();
    }

    get canBadgeRequests(): boolean {
        return this.userRuler.canBadgeRequest;
    }

    get canVisitorsRequests(): boolean {
        return this.userRuler.canVisitorsRequest;
    }
}
